<template>
  <div class="prosecute">
    <Row class="detail-header">
      <span>起诉</span>
      <ButtonGroup size="small" class="lawsuit-btn">
        <Button :type="tabActive=='submitMaterial'?'primary':'default'" @click="tabActive='submitMaterial'">递交材料</Button>
        <!-- :disabled="disabledCtrl || processState===2" -->
        <Button :type="tabActive=='mediateBeforeSue'?'primary':'default'" @click="tabActive='mediateBeforeSue'">诉前联调</Button>
        <!-- :disabled="disabledCtrl"  -->
        <Button :type="tabActive=='acceptance'?'primary':'default'" @click="tabActive='acceptance'">受理</Button>
      </ButtonGroup>
    </Row>
    <Row class="case-content">
      <submit-material v-if="tabActive=='submitMaterial'" v-bind="$attrs" :case-state="caseState" :process-id="processId" :case-id="caseId" @getAuditState="getState" v-on="$listeners" />
      <mediate-before-sue v-if="tabActive=='mediateBeforeSue'" v-bind="$attrs" :process-id="processId" :case-id="caseId" v-on="$listeners" />
      <acceptance v-if="tabActive=='acceptance'" v-bind="$attrs" :process-id="processId" :case-id="caseId" v-on="$listeners" />
    </Row>
  </div>
</template>
<script>
import submitMaterial from './submitMaterial.vue'
import acceptance from './acceptance.vue'
import mediateBeforeSue from './mediateBeforeSue.vue'
export default {
  components: {
    submitMaterial,
    acceptance,
    mediateBeforeSue
  },
  inheritAttrs: false,
  props: ['processId', 'caseId', 'processState', 'caseState'],
  data () {
    return {
      tabActive: 'submitMaterial',
      disabledCtrl: true
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
  },
  updated() {},
  methods: {
    getState(state) {
      this.disabledCtrl = !state
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../caseCommon.scss';
.prosecute{
    .case-content{
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/prosecute/index.vue